import React from 'react';
import PremiumFaceScanScreen from '../screens/PremiumFaceScanScreen';

export default function PremiumAnalysisPage(): React.JSX.Element {
  return <PremiumFaceScanScreen mode="page" />;
}
